export function getParams(sub_view) {
  return { sub_view }
}
